import { useContext } from 'react';
import { DialogContext } from '../../../components/Dialog/DialogProvider';

const useErrorDialog = () => {
  const { error } = useContext(DialogContext);

  return { error };
};

export default useErrorDialog;
